//获取两个日期间的全部日期
function getdiffdate(stime, etime) {
	//初始化日期列表，数组
	var diffdate = new Array();
	//开始日期小于等于结束日期,并循环
	console.log(stime, etime)
	while (new Date(etime) > new Date(stime)) {
		diffdate.push(stime)
		//获取开始日期时间戳
		var stime_ts = new Date(stime).getTime();
		// console.log('当前日期：' + stime + '当前时间戳：' + stime_ts);

		//增加一天时间戳后的日期
		var next_date = stime_ts + (24 * 60 * 60 * 1000);

		//拼接年月日，这里的月份会返回（0-11），所以要+1
		var next_dates_y = new Date(next_date).getFullYear() + '-';
		var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) +
			'-' : (new Date(next_date).getMonth() + 1) + '-';
		var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(
			next_date).getDate();

		stime = next_dates_y + next_dates_m + next_dates_d;
	}

	diffdate.push(etime)
	return diffdate;
}

function formatDate(date, fmt) {
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	}
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + ''
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
		}
	}
	return fmt
}

function padLeftZero(str) {
	return ('00' + str).substr(str.length)
}

function formatDateMy(date, fmt) {
	var o = {
		"M+": date.getMonth() + 1, //月份
		"d+": date.getDate(), //日
		"h+": date.getHours(), //小时
		"m+": date.getMinutes(), //分
		"s+": date.getSeconds(), //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		"S": date.getMilliseconds() //毫秒
	};
	console.log(o)
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
				.length)));
		}
	}
	return fmt
}

function getDatenow(fmt) {
	var ddnow = new Date();
	let retdate = formatDate(ddnow, fmt);
	return retdate;
	// var yy = ddnow.getFullYear();
	// var mm = ddnow.getMonth() + 1; //获取当前月份的日期
	// var dd = ddnow.getDate();
	// mm = String(mm < 10 ? '0' + mm : mm);
	// dd = String(dd < 10 ? '0' + dd : dd);
	// let end = yy + "-" + mm + "-" + dd;
}

function GetDateStr(AddDayCount, fmt) {
	var day = new Date();
	day.setDate(day.getDate() + AddDayCount); //获取AddDayCount天后的日期
	let retdate = formatDate(day, fmt);
	return retdate;
	// var y = day.getFullYear();
	// var m = day.getMonth() + 1; //获取当前月份的日期
	// var d = day.getDate();
	// m = String(m < 10 ? '0' + m : m);
	// d = String(d < 10 ? '0' + d : d);
	// let beg = y + "-" + m + "-" + d;

	// return  y + "-" + m + "-" + d;
}

function getFormatDate(date, dateType) {
	let dateObj = new Date(date);
	let month = dateObj.getMonth() + 1;
	let strDate = dateObj.getDate();
	let hours = dateObj.getHours();
	let minutes = dateObj.getMinutes();
	let seconds = dateObj.getSeconds();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;

	}
	if (hours >= 0 && hours <= 9) {
		hours = "0" + hours
	}
	if (minutes >= 0 && minutes <= 9) {
		minutes = "0" + minutes
	}
	if (seconds >= 0 && seconds <= 9) {
		seconds = "0" + seconds
	}
	// 星期
	let weekDay;
	let now_day = dateObj.getDay();
	switch (now_day) {
		case 0: {
			weekDay = "星期日"
		}
		break;
	case 1: {
		weekDay = "星期一"
	}
	break;
	case 2: {
		weekDay = "星期二"
	}
	break;
	case 3: {
		weekDay = "星期三"
	}
	break;
	case 4: {
		weekDay = "星期四"
	}
	break;
	case 5: {
		weekDay = "星期五"
	}
	break;
	case 6: {
		weekDay = "星期六"
	}
	break;
	case 7: {
		weekDay = "星期日"
	}
	break;
	}
	let dateText = dateObj.getFullYear() + '年' + (dateObj.getMonth() + 1) + '月' + dateObj.getDate() + '日';
	if (dateType == "yyyy-mm-dd") {
		dateText = dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate();
	}
	if (dateType == "yyyy.mm.dd") {
		dateText = dateObj.getFullYear() + '.' + (dateObj.getMonth() + 1) + '.' + dateObj.getDate();
	}
	if (dateType == "yyyy-mm-dd MM:mm:ss") {
		dateText = dateObj.getFullYear() + '-' + month + '-' + strDate + ' ' + hours + ":" + minutes + ":" + seconds;
	}
	if (dateType == "yyyy-mm-dd MM:mm") {
		dateText = dateObj.getFullYear() + '-' + month + '-' + strDate + ' ' + hours + ":" + minutes;
	}
	if (dateType == "mm-dd MM:mm:ss") {
		dateText = month + '-' + strDate + ' ' + hours + ":" + minutes + ":" + seconds;
	}
	if (dateType == "mm-dd") {
		dateText = month + '-' + strDate;
	}
	if (dateType == "mm-dd MM:mm") {
		dateText = month + '-' + strDate + '  ' + hours + ':' + minutes;
	}
	if (dateType == "yyyy年mm月dd日 MM:mm:ss") {
		dateText = dateObj.getFullYear() + '年' + month + '月' + strDate + '日' + ' ' + hours + ":" + minutes + ":" + seconds;
	}
	if (dateType == "yyyy-mm-dd weekDay MM:mm") {
		dateText = dateObj.getFullYear() + '-' + month + '-' + strDate + ' ' + weekDay + ' ' + hours + ":" + minutes;
	}
	if (dateType == "yyyymm/dd/MM") {
		dateText = dateObj.getFullYear() + month + '/' + strDate + '/' + hours + "/";
	}
	if (dateType == "MM") {
		dateText = hours;
	}
	return dateText;
}

export {
	getdiffdate,
	formatDate,
	getDatenow,
	GetDateStr,
	getFormatDate
}
